import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import SwitchBlockComponent from '@websky/core/src/FareLock/components/SwitchBlock/SwitchBlock';
import Switch from '@websky/core/src/Switch/components/Switch';
import { useTheme } from '@websky/core/src/theme';
import { Money } from '@websky/core';
import theme from './SwitchBlock.css';
const SwitchBlock = props => {
    const { SwitchBlock: css } = useTheme('FareLock');
    const { t } = useTranslation('FareLock');
    const renderSwitch = useCallback(({ isActive, onClick }) => {
        return (React.createElement("div", { className: theme.switch__root },
            React.createElement("span", { className: theme.switch__text },
                t('Lock fare'),
                React.createElement(Money, { money: props.price })),
            React.createElement(Switch, { labelClassName: css.switch_label, mainClassName: css.switch_control, activeClassName: css.switch_active, label: '', isActive: isActive, switchPosition: "left", onClick: onClick })));
    }, []);
    return React.createElement(SwitchBlockComponent, Object.assign({}, props, { renderSwitch: renderSwitch }));
};
export default SwitchBlock;
